module.exports = function() {
  return new Worker(__webpack_public_path__ + "3d1706bca741b10e908e.worker.js");
};